import { AiUseCase } from '@einwert/valuation-api-client'
import { useTenantImportDownload, type TenantImportLanguage } from '@einwert/tenant-import'
import { getValuationApiClient } from 'ClientPortal/src/api/valuationApiClient'

export function useTenantListImport(language: TenantImportLanguage) {
    return useTenantImportDownload({
        language,
        invokeWorkflow: (request, options) =>
            getValuationApiClient().ai.invokeWorkflowWithAsyncPolling({ agentUseCase: AiUseCase.TENANT_IMPORT, request, ...options }),
    })
}
